export default "__VITE_ASSET__4wGPCTeV__"